// @flow

import Notification from '@/lib/notification';

export default class {
  notifications: Notification[];
  removed: Notification[];
  flags: string[]; // 一回だけ表示したいとか
  lastId: number;

  constructor() {
    this.notifications = [];
    this.removed = [];
    this.flags = [];
    this.lastId = 0;
  }

  hasFlag(flag: string): boolean {
    return this.flags.includes(flag);
  }

  create(params: { [string]: any }): Notification {
    this.lastId++;
    const notification = new Notification({ id: this.lastId, ...params });
    this.notifications.push(notification);
    return notification;
  }

  createIfHasNotFlag(
    flag: string,
    params: { [string]: any }
  ): Notification | null {
    if (!this.hasFlag(flag)) {
      this.flags.push(flag);
      return this.create(params);
    }

    return null;
  }

  find(id: number): Notification | null {
    return (
      this.notifications.find(notification => {
        return !!notification && notification.id === id;
      }) || null
    );
  }

  remove(id: number) {
    const index = this.notifications.findIndex(notification => {
      return !!notification && notification.id === id;
    });

    if (Number.isInteger(index)) {
      this.notifications[index].open();
      this.removed.push(this.notifications[index]);
      this.notifications.splice(index, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/notification_manager/notification_manager.js